var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "mirror-in-rtl": "true",
    fill: "#000000",
    transform: "matrix(-1, 0, 0, 1, 0, 0)rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M21.995 18.002c-.655 0-1.27-.313-1.646-.836-.025-.033-.055-.08-.084-.132h-.002c-.66-1.05-1.76-1.7-3.27-1.937-.04.717-.477 1.374-1.136 1.693-.595.325-1.528.247-2.127-.253L8.75 12.55c-.476-.375-.75-.94-.75-1.548 0-.61.28-1.2.75-1.573l4.998-4c.623-.466 1.41-.554 2.084-.25.707.316 1.165 1.03 1.165 1.82v.248c2.863.942 7.185 3.674 6.997 8.79 0 1.067-.896 1.964-2 1.964zm-5.998-5h.035c2.747.098 4.736 1.09 5.915 2.953.238-5.346-5.924-6.918-6.187-6.982-.447-.11-.764-.51-.764-.972V7L10 10.99l4.998 4v-.988c0-.272.11-.53.305-.72.186-.18.435-.28.694-.28zm-5.997-2c0-.002 0-.006-.003-.01M7.997 13h-.002.028-.026zM8.99 15.1c.01-.03.01-.07.01-.1v.1h-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M9 15c0 .03 0 .07-.01.1 0 .04 0 .08-.01.11-.07.67-.49 1.28-1.12 1.58-.6.32-1.53.25-2.13-.25L.75 12.55C.27 12.17 0 11.61 0 11s.28-1.2.75-1.57l5-4c.62-.47 1.41-.56 2.08-.25C8.54 5.49 9 6.21 9 7c0 .55-.45 1-1 1s-1-.45-1-1l-5 3.99 5 4c.01-.55.45-.99 1-.99s1 .45 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.1024f92ee290e716d9878c8ebe3daf0e.svg";
export { ForwardRef as ReactComponent };